var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cards",style:({'--per-row': _vm.perRow})},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }